enum PensionAgreementType {
  PKKI = 'PKKI',
  PKKL = 'PKKL',
  IPI = 'IPI',
  IPIP = 'IPIP',
  IPS = 'IPS',
  IPA = 'IPA',
  LIVRENTE = 'LIVRENTE',
  KAPITAL = 'KAPITAL',
  YTELSE = 'YTELSE',
  FRIPOLISE = 'FRIPOLISE',
  RISIKOFORSIKRING = 'RISIKOFORSIKRING',
  KOMPENSASJONSORDNING = 'KOMPENSASJONSORDNING',
  TJENESTEPENSJON = 'TJENESTEPENSJON',
  PKKISECURED = 'PKKI_SECURED',
  PKKLSECURED = 'PKKL_SECURED',
  INNSKUDDSPENSJONFLEX = 'INNSKUDDSPENSJON_FLEX',
  NEWIPS = 'NEW_IPS',
  UNDEFINED = 'UNDEFINED',
}

export default PensionAgreementType;
